/**
 * Contact Method-related strings.
 */
import React from 'react';

export default {
    d_title: 'Contact Methods',
    h_title: <div>
        <p>There are three types of contact methods supported: <b>phone, email and address</b>.</p>
        <p>Each of these has attributes, like <b>Is Primary</b>, <b>Can Contact</b> and <b>Is Current</b>.</p>
        <p><b>Is Primary</b> can only exist on one of each type of contact method, and is used to automatically
            select that method when it is required.</p>
        <p>For example, when setting up payment methods, we will
            prefill the <b>primary</b> email, address and phone number for you. You can always change them later, of
            course.
        </p>
        <p><b>Can Contact</b> says that this resource should never be used for correspondence. For example, if the
            email can be accessed by the opposing party. As such, it is never auto-selected, even if it is the only
            contact method of its type. It will also be shown in <span
                style={{color: 'maroon'}}><s>strikeout</s></span> to visually inform you not to use it.</p>
        <p><b>Is Current</b> is only used with addresses. Flag this if there are many addresses for the contact, but
        this is the one they are currently receiving mail at.</p>
    </div>,

    d_portal_title: 'Your emails, phone numbers and addresses',
    h_portal_title: '<div><p>It is important that we know all of your contact information, including those shared with your spouse or family.</p><p>For each kind of contact method, please mark ONE as primary. Primary methods should NOT be shared with anyone else, and you should be absolutely sure that nobody else can access them. If you think an email is compromised, or you mail is being read by another person, consider using a different account or address.</p><p>You can mark a contact method as Do Not Contact, and we will never contact you that way.</p><p>If required, please list old addresses, and uncheck the Current checkbox.</p></div>'
};